export default {"src":"/_next/static/media/claimnowicons.cfccb5f9.svg","height":193,"width":312,"blurWidth":0,"blurHeight":0};